module.exports = __webpack_public_path__ + "img/tips.aa793f7f.png";